var _style, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 98",
    style: {
      enableBackground: "new 0 0 1920 98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#087DC1;}\n\t.st1{fill:#FFDC00;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0,
    className: "st0",
    width: 1920,
    height: 98
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,0v43.61c0,0,68.2-16.46,141.44-21.81c73.24-5.34,136.39-7.56,296.35,14.68s277.83,10.24,328.34-0.89 c50.51-11.12,58.93-16.91,58.93-16.91V0H0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1209.28,0v43.61c0,0-68.2-16.46-141.44-21.81c-73.24-5.34-136.39-7.56-296.35,14.68 S493.67,46.73,443.16,35.6c-50.51-11.12-58.93-16.91-58.93-16.91l0-18.69L1209.28,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M711.22,0v43.61c0,0,68.2-16.46,141.44-21.81c73.24-5.34,136.39-7.56,296.35,14.68s277.83,10.24,328.34-0.89 c50.51-11.12,58.93-16.91,58.93-16.91V0H711.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1920,0v43.61c0,0-68.2-16.46-141.44-21.81c-73.24-5.34-136.39-7.56-296.35,14.68s-277.83,10.24-328.34-0.89 c-50.51-11.12-58.93-16.91-58.93-16.91V0L1920,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader);
export default __webpack_public_path__ + "static/media/header.dc54e3fb11e9f220b081a523e77b3172.svg";
export { ForwardRef as ReactComponent };